/* so-pdp.js — T1 product page (2026-09-30). Phone gallery dots only: a 7-dot window around the current slide
   (the edge dots shrink when there are more slides), drawn from the gallery's own counter
   (.media-ctrl__current-item / __total-items, which media-gallery.js keeps up to date on swipe, arrow and
   variant change). Decoration only (aria-hidden); the gallery, its counter text and its live region are untouched.
   Hidden from 768px by so-pdp.css. */
(function () {
  'use strict';
  if (window.__soPdpLoaded) return; window.__soPdpLoaded = true;   // also loaded site-wide by quick-add-drawer.liquid
  var W = 7;
  function draw(box, cur, n) {
    var start = Math.max(0, Math.min(cur - 3, n - W)), end = Math.min(n, start + W), html = '';
    for (var i = start; i < end; i++) {
      var cls = i === cur ? 'is-on' : '';
      if ((i === start && start > 0) || (i === end - 1 && end < n)) cls += ' is-sm';
      html += '<i class="' + cls.trim() + '"></i>';
    }
    if (box.innerHTML !== html) box.innerHTML = html;
  }
  function init() {
    var gallery = document.querySelector('.product-media media-gallery') || document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.so-pdp-dots')) return;
    var viewer = gallery.querySelector('.media-gallery__viewer');
    var curEl = gallery.querySelector('.media-ctrl__current-item');
    var totEl = gallery.querySelector('.media-ctrl__total-items');
    if (!viewer || !curEl || !totEl) return;
    var box = document.createElement('div');
    box.className = 'so-pdp-dots';
    box.setAttribute('aria-hidden', 'true');
    viewer.appendChild(box);
    var update = function () {
      var n = parseInt(totEl.textContent, 10) || 0, cur = (parseInt(curEl.textContent, 10) || 1) - 1;
      box.hidden = n < 2;
      if (n > 1) draw(box, Math.max(0, Math.min(cur, n - 1)), n);
    };
    update();
    var mo = new MutationObserver(update);
    mo.observe(curEl, { childList: true, characterData: true, subtree: true });
    mo.observe(totEl, { childList: true, characterData: true, subtree: true });
  }
  // "About this product": show "Read more" only when the description is really clamped; one way (opens in place).
  function about() {
    var d = document.querySelector('[data-so-about-desc]'), b = document.querySelector('[data-so-about-more]');
    if (!d || !b) return;
    b.hidden = !(d.scrollHeight > d.clientHeight + 4);
    if (b.hidden) { d.classList.remove('is-clamped'); return; }
    b.addEventListener('click', function () {
      var open = d.classList.toggle('is-clamped') === false;
      b.textContent = open ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', String(open));
      if (!open && d.getBoundingClientRect().top < 0) d.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }
  // "Goes well with these" (so-fbt rows): a one-variant add-on goes straight into the cart — the same /cart/add.js call
  // + cart-drawer refresh so-fbt used (renders the drawer and icon, opens it when the theme's after-add setting is
  // 'drawer'). Multi-variant rows are .js-quick-add buttons, handled by the theme's quick-add drawer.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-so-fbt-add1]');
    if (!b || b.dataset.busy || b.classList.contains('is-added')) return;
    var mod = b.closest('.so-fbt'), err = mod && mod.querySelector('[data-so-fbt-err]');
    var cd = document.querySelector('cart-drawer'), sections = 'cart-icon-bubble';
    if (cd && cd.closest('.shopify-section')) sections += ',' + cd.closest('.shopify-section').id.replace('shopify-section-', '');
    b.dataset.busy = '1'; b.setAttribute('aria-disabled', 'true'); if (err) err.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-variant-id'), quantity: +(b.getAttribute('data-qty') || 1) }], sections: sections, sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (r) {
        if (!r.ok) throw (r.body && (r.body.description || r.body.message)) || 'Could not add to cart.';
        var open = !!(window.theme && theme.settings && theme.settings.afterAtc === 'drawer');
        if (cd && cd.renderContents && r.body.sections) cd.renderContents(r.body, open);
        b.textContent = '✓ Added'; b.classList.add('is-added');
      })
      .catch(function (m) { if (err) { err.textContent = typeof m === 'string' ? m : 'Something went wrong — please try again.'; err.hidden = false; } })
      .then(function () { b.dataset.busy = ''; b.removeAttribute('aria-disabled'); });
  });
  // Colour chips (T1, Charl: "not the colour icons… cramped and lifeless"): every swatch-style option in the buy block
  // becomes pill chips "● Matte White" — the same radio inputs underneath (variant change, sticky, JSON-LD unchanged);
  // this only adds a dot (or a tiny round crop of the variant image) + the name inside each existing label.
  function chips(root) {   // root = the quick-add panel's content (window.soPdp.chips); default = the PDP
    var map = {}; try { map = JSON.parse(((root && root.querySelector('#so-colour-map')) || document.getElementById('so-colour-map') || {}).textContent || '{}'); } catch (e) { map = {}; }
    (root || document).querySelectorAll(root ? '.option-selector' : '.product-info .option-selector').forEach(function (fs) {
      var labels = fs.querySelectorAll('label.opt-label--swatch');
      if (!labels.length || fs.classList.contains('so-chips') || fs.hasAttribute('data-so-row-label')) return;   // a bundle's long colour list is a picker row with its own label
      fs.classList.add('so-chips');
      labels.forEach(function (lab) {
        var inp = document.getElementById(lab.getAttribute('for')); if (!inp) return;
        var val = inp.value, c = map[val] || {};
        var dot = document.createElement('span'); dot.className = 'so-chip__dot'; dot.setAttribute('aria-hidden', 'true');
        if (c.hex) dot.style.background = c.hex;
        else if (c.img) { dot.style.backgroundImage = 'url("' + String(c.img).replace(/"/g, '') + '")'; dot.classList.add('is-img'); }
        var t = document.createElement('span'); t.className = 'so-chip__t'; t.textContent = val;
        lab.appendChild(dot); lab.appendChild(t);
      });
    });
  }
  // PDP info pop-ups — the bundles sheet (so-pdp-bundle "See all N ›") and Specifications (so-pdp-specs "See all specs ›"):
  // any [data-so-sheet-open aria-controls="<id>"] opens that .so-dsheet--info; [data-so-sheet-close] / Esc / backdrop close.
  (function () {
    var sheet = null, from = null, saved = null;
    function key(e) {
      if (!sheet) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(sheet.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var a = document.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey ? (a === first || f.indexOf(a) < 0) : (a === last || f.indexOf(a) < 0)) { (e.shiftKey ? last : first).focus(); e.preventDefault(); }
    }
    function close() {
      if (!sheet) return;
      var s = sheet; sheet = null;
      s.classList.remove('is-open'); s.classList.add('is-closing');
      s._t = setTimeout(function () { s.hidden = true; s.classList.remove('is-closing'); }, 260);
      if (saved) { document.documentElement.style.overflow = saved.h; document.body.style.overflow = saved.b; saved = null; }
      document.removeEventListener('keydown', key, true);
      if (from && from.isConnected) from.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null; if (!t) return;
      if (sheet && t.closest('[data-so-bundles-close], [data-so-sheet-close]')) { close(); return; }
      var b = t.closest('[data-so-bundles-open], [data-so-sheet-open]'); if (!b || sheet) return;
      var s = document.getElementById(b.getAttribute('aria-controls')); if (!s) return;
      if (s.parentNode !== document.body) document.body.appendChild(s);   // out of the buy column's stacking context (gallery arrows, header)
      sheet = s; from = b;
      saved = { h: document.documentElement.style.overflow, b: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', key, true);
      clearTimeout(s._t); s.classList.remove('is-closing'); s.hidden = false;
      var panel = s.querySelector('.so-dsheet__panel');
      if (window.soSheetSwipe && panel) window.soSheetSwipe.attach(panel, { handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body', backdrop: s.querySelector('.so-dsheet__backdrop'), onClose: close });
      void s.offsetWidth; s.classList.add('is-open');
      var h = s.querySelector('.so-dsheet__title'); if (h) h.focus({ preventScroll: true });
    });
  })();
  // Bundle carousel arrows (desktop): one card per click
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-so-pbunc-step], [data-so-car-step]'); if (!b) return;   // bundles + "Goes well with these"
    var row = b.closest('.so-pbunc, [data-so-car]').querySelector('[data-so-pbunc-row], [data-so-car-row]'), li = row && row.querySelector('li'); if (!li) return;
    row.scrollBy({ left: Number(b.getAttribute('data-so-pbunc-step') || b.getAttribute('data-so-car-step')) * (li.getBoundingClientRect().width + 8), behavior: 'smooth' });
  });
  // "More like this" does not repeat the products already in "Similar products" — when it has at least 2 others to show.
  function dedupeRail() {
    var tries = 0, t = setInterval(function () {
      var sim = document.querySelector('[data-so-fbt-similar]'), rails = [].slice.call(document.querySelectorAll('product-recommendations')).filter(function (r) { return !r.querySelector('.so-fbt') && r.querySelector('product-card'); });
      if (++tries > 30) { clearInterval(t); return; }
      if (!document.querySelector('.so-fbt') || !rails.length) return;          // not loaded yet
      clearInterval(t); if (!sim) return;
      var seen = {}; [].slice.call(sim.querySelectorAll('product-card')).forEach(function (c) { var id = c.getAttribute('data-so-pid'); if (id) seen[id] = 1; });
      rails.forEach(function (rail) {
        var cards = [].slice.call(rail.querySelectorAll('product-card')), dup = cards.filter(function (c) { return seen[c.getAttribute('data-so-pid')]; });
        if (!dup.length || cards.length - dup.length < 2) return;
        dup.forEach(function (c) { (c.closest('li') || c).hidden = true; (c.closest('li') || c).style.display = 'none'; });
      });
    }, 500);
  }
  // Carousel arrows (bundles + add-ons): shown on desktop only when the row really overflows
  function carNav() {
    [].slice.call(document.querySelectorAll('.so-pbunc, [data-so-car]')).forEach(function (c) {
      var row = c.querySelector('[data-so-pbunc-row], [data-so-car-row]'), nav = c.querySelector('.so-pbunc__nav'); if (!row || !nav) return;
      nav.hidden = !(row.scrollWidth > row.clientWidth + 4);
    });
  }
  window.addEventListener('resize', carNav);
  (function () { var n = 0, t = setInterval(function () { carNav(); if (++n > 20) clearInterval(t); }, 500); })();   // the add-ons arrive by section rendering
  // Desktop: the SHORTER column is the sticky one. The buy column is usually the longer one now (trust cards, bundle
  // carousel, add-ons), so the gallery stays in view under the header while the buy column scrolls; when the gallery is
  // the taller one the theme's own sticky buy column is left alone. so-pdp.css does the layout; phones are untouched.
  function stickyCols() {
    var info = document.querySelector('.cc-main-product .product-info'), prod = info && info.parentElement, media = prod && prod.querySelector(':scope > .product-media');
    if (!info || !media) return;
    var set = function () { prod.classList.toggle('so-sticky-media', media.offsetHeight + 8 < info.offsetHeight); };
    set(); window.addEventListener('resize', set);
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(set); ro.observe(info); ro.observe(media); }
  }
  // Flavour guide (live's so-flavour-guide, 2026-10-14, Charl: "where are the links to select it?"): each flavour name
  // on the MAIN product's Flavour row (not a quick-add panel's) becomes a button that picks it and scrolls back to the
  // picker, with focus on the picker. The pick is always a real variant: the other choices (strength, colour …) stay
  // when that combination exists, otherwise the first available variant with this flavour (else the first one) is
  // chosen; every row's radio is set and one change event runs the theme's own update (price, photo, stock, URL,
  // drawer row, sticky bar). On live's so-variant-seo pilot products the name is a ?variant= link: it stays a link (for
  // crawlers and new-tab clicks) and a plain tap picks in place. Names not on the picker stay text.
  function flavourPick() {
    var root = document.querySelector('[data-so-pdpflav]');
    var picker = document.querySelector('.cc-main-product .product-info variant-picker');
    if (!root || !picker || root.dataset.soPick) return;
    var data = picker.data;
    if (!data) { try { data = JSON.parse(picker.querySelector('[type="application/json"]').textContent); } catch (err) { return; } }
    var product = data && data.product; if (!product || !product.options) return;
    var names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var fi = -1; for (var i = 0; i < names.length; i++) if (names[i].indexOf('Flavour') > -1) { fi = i; break; }   // so-flavour-guide's rule
    var rows = picker.querySelectorAll('.option-selector');
    if (fi < 0 || rows.length !== names.length) return;
    var norm = function (t) { return String(t).replace(/\s+/g, ' ').trim(); };
    var byValue = function (row) { var m = {}; row.querySelectorAll('input.js-option[type="radio"]').forEach(function (r) { m[norm(r.value)] = r; }); return m; };
    var flav = byValue(rows[fi]);
    root.dataset.soPick = '1';
    var missed = [];
    root.querySelectorAll('li > strong').forEach(function (s) {
      var name = norm(s.textContent); if (!flav[name]) { missed.push(name); return; }
      var a = s.querySelector('a');
      if (a) { a.classList.add('so-fg-pick'); a.dataset.value = name; a.setAttribute('aria-label', 'Choose ' + name); return; }   // live's link stays for crawlers; a tap picks in place
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'so-fg-pick'; b.dataset.value = name; b.setAttribute('aria-label', 'Choose ' + name);
      while (s.firstChild) b.appendChild(s.firstChild);   // keep whatever markup the name has
      s.appendChild(b);
    });
    if (missed.length && window.console) console.warn('so-pdp flavour guide: not on the picker —', missed.join(', '));
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.so-fg-pick'); if (!b) return;
      if (b.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;   // new tab / window: the link as is
      var name = b.dataset.value, vs = (picker.data && picker.data.product || product).variants || [];
      var cur = Array.prototype.map.call(rows, function (row) { var c = row.querySelector('input.js-option:checked'); return c ? norm(c.value) : null; });
      var same = function (v) { return v.options.every(function (o, k) { return k === fi ? norm(o) === name : cur[k] === null || norm(o) === cur[k]; }); };
      var withFlav = vs.filter(function (v) { return norm(v.options[fi]) === name; });
      var v = withFlav.filter(same)[0] || withFlav.filter(function (x) { return x.available; })[0] || withFlav[0];
      if (!v) return;
      e.preventDefault();
      var target = null;
      v.options.forEach(function (o, k) { var r = byValue(rows[k])[norm(o)]; if (r) { r.checked = true; if (k === fi) target = r; } });
      if (!target) return;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      var row = rows[fi];
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusEl = row.querySelector('.so-vd__trigger') || target;
      setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (err) {} }, 50);
    });
  }
  window.soPdp = { chips: chips };
  function boot() { chips(); init(); about(); dedupeRail(); carNav(); stickyCols(); flavourPick(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
